
import React from 'react'
import icon from './svgs/square-user.svg'
import { BaseIcon } from './_base'

export const SquareUserIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
